import React, { useState } from 'react';
import rocketmanTransport, { isSoaringGame } from '../../../services/RocketmanTransport';
import { useRocketmanTransport } from '../../rocketman/RocketmanTransportContext';
import Currency from '../../Currency/Currency';
import JackpotOdometer from '../../JackpotOdometer';
import JackpotCurrentWinners from '../../Retail/JackpotCurrentWinners';

export default function BoosterPotHolder({ gameName }) {
  const [currentBoosterpotData, setCurrentBoosterpotData] = useState([]);
  // const [currentBoosterpotData, setCurrentBoosterpotData] = useState([  {
  //   jp_name: "Boosterpot",
  //   ticket_id: "0209747103",
  //   shop: "Beograd na vodi",
  //   jp_value: 10000,
  //   jp_level: 2
  // }]);

  const rocketmanContext = useRocketmanTransport();
  const jackpotData = rocketmanContext.jackpotData;
  const boosterpotValue = jackpotData?.find(jp => jp.level === 2)?.value || 0;
  const boosterpotLabel = jackpotData?.find(jp => jp.level === 2)?.label || 0;
  const hasJackpot = (name) => currentBoosterpotData?.some(jp => jp.jp_level === 2);
  window.setCurrentBoosterpotData = setCurrentBoosterpotData;

  return (
    <div className="jackpot-cash-holder">
      {currentBoosterpotData?.length > 0 && hasJackpot("Boosterpot") ? <JackpotCurrentWinners currentJackpot={currentBoosterpotData.filter(jp => jp.jp_level === 2)} /> : null}
      {rocketmanTransport.retail ? <span style={{ marginBottom: -6}} className='jackpot-title-retail mr-2'>{boosterpotLabel}</span> : null} <JackpotOdometer value={Number(Number(boosterpotValue)).toFixed(rocketmanTransport.noOfDecimals)} format={2} duration={60} /> <Currency className={"jackpot-currency " + (rocketmanTransport.r7css ? "r7css" : "")}>{rocketmanTransport.myCurrency}</Currency>
    </div>
  )
}
